import React, { useMemo, useState } from "react";
import AccountGroupTable from "./AccountGroupTable";

const AccountGroupWorkspace = ({ accountGroups = [], ledgers = [] }) => {
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    const groupsWithLedgerCount = useMemo(() => {
        return accountGroups.map((group) => {
        const ledgerCount = ledgers.filter(
            (ledger) => ledger.group_id === group.id,
        ).length;

        return {
            ...group,
            ledgerCount,
        };
        });
    }, [accountGroups, ledgers]);

    const filteredGroups = groupsWithLedgerCount.filter((group) => {
        const query = search.trim().toLowerCase();

        const matchesSearch =
        !query ||
        group.name?.toLowerCase().includes(query) ||
        group.code?.toLowerCase().includes(query) ||
        group.parent_name?.toLowerCase().includes(query);

        const matchesStatus =
        statusFilter === "all" ||
        (statusFilter === "active"
            ? group.is_active !== false
            : group.is_active === false);

        return matchesSearch && matchesStatus;
    });

    const systemGroups = accountGroups.filter((group) => group.is_system).length;

    const customGroups = accountGroups.length - systemGroups;

    return (
        <section className="account-group-workspace">
            <div className="workspace-header">
                <div>
                    <span className="workspace-eyebrow">ACCOUNTING STRUCTURE</span>

                    <h3>Account Groups</h3>

                    <p>
                        Organise ledgers into meaningful accounting categories and reporting structures.
                    </p>
                </div>

                <div className="workspace-summary">
                    <strong>{filteredGroups.length}</strong>

                    <span>of {accountGroups.length} groups</span>
                </div>
            </div>

            <div className="ledger-insights">
                <div>
                    <strong>{accountGroups.length}</strong>
                    <span>Total groups</span>
                </div>

                <div>
                    <strong>{systemGroups}</strong>
                    <span>System groups</span>
                </div>

                <div>
                    <strong>{customGroups}</strong>
                    <span>Custom groups</span>
                </div>
            </div>

            <div className="ledger-toolbar">
                <div className="ledger-search">
                    <span>⌕</span>

                    <input
                        type="text"
                        placeholder="Search account group..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="all">All statuses</option>

                    <option value="active">Active</option>

                    <option value="inactive">Inactive</option>
                </select>
            </div>

            <AccountGroupTable accountGroups={filteredGroups} />
        </section>
    );
};

export default AccountGroupWorkspace;
